import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm} from 'redux-form'
import FormFieldText from '../../../components/uiKit/FormFieldText'
import Button from '../../../components/uiKit/Button'
import GoogleLogin from 'react-google-login'
import ReCaptchaField from '../ReCaptchaField'


const required = value => value ? undefined : 'Please choose a password to sign-in to Plickers with.'
// const email = value =>
// 	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
// 		'Are you sure thats an email?' : undefined

class AddPasswordToGoogleForm extends React.Component{

	render(){

		return(			
			<form onSubmit={this.props.handleSubmit} autoComplete='off'>				    				    			          

				<Field 
	        		name='email'
	        		type='text'
			        component={FormFieldText}
			        disabled
			        size='large'
				  />

			    <Field 
	      		name='newPassword'
	      		type='password'
	      		label='Password'
		        component={FormFieldText}	
		        autoFocus={true}        
		        validate={[required]}				        
		        size='large'
		        subLabel='Choose a password. Your password must be at least 6 characters.'
			    />

				  <Field name='recaptchaResponse' component={ReCaptchaField}/> 
				    
				 	<div className='accountForm-actionRow'>						
				 		<GoogleLogin
						clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
						onSuccess={(googleUser)=>{this.props.addPassword(googleUser)}}
						onFailure={this.props.responseGoogle}
						className='addPassword-actionRow-googleLogin--container'
						tag='div'
						loginHint={this.props.email}          		
	          			>
			            	<Button
			            		size='xLarge'
			            		label='Authenticate with Google to Confirm'
			            		color={this.props.dirty && this.props.valid ? 'blue' : 'gray'}
			            		canSubmit={this.props.dirty && this.props.valid ? true : false}
			            		type='submit' 
			            	/>
					 	</GoogleLogin>
	       	</div>
	    </form>			 
		)
	}
}





const mapStateToProps = (state,ownProps) => {
	return {
		initialValues: {
			email:ownProps.email,
		}
	}
}

AddPasswordToGoogleForm = reduxForm({
	form: 'addPasswordForm',
	enableReinitialize: true,
	autoComplete:'off'
})(AddPasswordToGoogleForm)

export default connect(mapStateToProps)(AddPasswordToGoogleForm)



